import React from 'react'

import { Skeleton } from '@fourthwall/components'

export const HeaderSkeleton = () => (
  <div style={{ marginBottom: 32 }}>
    <Skeleton>
      <Skeleton.Shape width="100%" height={60} />
    </Skeleton>
  </div>
)
